/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Hour_Wolf_PushInputs */

const fr_wild_hour_wolf_push = /** @type {(inputs: Wild_Hour_Wolf_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App`)
};

/**

* @param {Wild_Hour_Wolf_PushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wild_hour_wolf_push = /** @type {((inputs?: Wild_Hour_Wolf_PushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Hour_Wolf_PushInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wild_hour_wolf_push(inputs)
});